import { Stepper } from "@mantine/core";
import {
  ENUMPOASteps,
  usePOAStepsStore,
} from "../../hooks/ui/poaStepsDataStore";
import { useEffect, useState } from "react";
import { useMediaQuery } from "@mantine/hooks";
import classes from "./index.module.css";

export default function POAStepper() {
  const { currentStep } = usePOAStepsStore();
  const [stepperStep, setStepperStep] = useState(0);
  const isMobile = useMediaQuery("(max-width: 56.25em)");

  useEffect(() => {
    switch (currentStep) {
      case ENUMPOASteps.IDENTIFY:
        setStepperStep(0);
        break;
      case ENUMPOASteps.EMAILANDPHONE:
        setStepperStep(1);
        break;
      case ENUMPOASteps.POAINFO ||
        ENUMPOASteps.POADURATION ||
        ENUMPOASteps.POACONFIRMATION ||
        ENUMPOASteps.POASIGN:
        setStepperStep(2);
        break;
      case ENUMPOASteps.BOOKMEETING:
        setStepperStep(3);
        break;
      case ENUMPOASteps.POASUMMARY:
        setStepperStep(4);
        break;
      default:
        break;
    }
  }, [currentStep]);

  return (
    <Stepper
      active={stepperStep}
      color="var(--wallet-color-sambla-red-shade-600)"
      mt={"xl"}
      mb={"xl"}
      size={isMobile ? "xs" : "md"}
      iconSize={isMobile ? 32 : 42}
      classNames={{
        separator: classes.separator,
        steps: classes.steps,
        root: classes.root,
      }}
    >
      <Stepper.Step label="Legitimering" completedIcon={1} />
      <Stepper.Step label="Kontaktuppgifter" completedIcon={2} />
      <Stepper.Step label="Lämna fullmakt" completedIcon={3} />
      <Stepper.Step label="Boka rådgivning" completedIcon={4} />
    </Stepper>
  );
}
